import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const getConfig = () => api.get("/config").then((r) => r.data);
export const getAvailability = () => api.get("/availability").then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const joinWaitlist = (payload) => api.post("/waitlist", payload).then((r) => r.data);
export const adminGetWaitlist = (token) =>
  api.get("/admin/waitlist", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminRemoveWaitlist = (token, id) =>
  api.delete(`/admin/waitlist/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const getBookingByRef = (ref) => api.get(`/bookings/${ref}`).then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = (token) =>
  api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminLogout = () => api.post("/auth/logout").then((r) => r.data);
export const adminListUsers = (token) =>
  api.get("/admin/users", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminCreateUser = (token, payload) =>
  api.post("/admin/users", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminUpdateUser = (token, id, patch) =>
  api.patch(`/admin/users/${id}`, patch, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminDeleteUser = (token, id) =>
  api.delete(`/admin/users/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminGetBookings = (token) =>
  api.get("/admin/bookings", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminCancelBooking = (token, id) =>
  api.delete(`/admin/bookings/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminUpdateNotes = (token, id, admin_notes) =>
  api
    .patch(`/admin/bookings/${id}/notes`, { admin_notes }, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminUpdateBooking = (token, id, patch) =>
  api
    .patch(`/admin/bookings/${id}`, patch, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminSendReminder = (token, id) =>
  api
    .post(`/admin/bookings/${id}/send-reminder`, {}, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminSendInvoice = (token, id) =>
  api
    .post(`/admin/bookings/${id}/send-invoice`, {}, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminSendInvoiceBulk = (token, ids) =>
  api
    .post(`/admin/bookings/invoice/send`, { booking_ids: ids }, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);
export const adminTogglePaid = (token, id) =>
  api
    .post(`/admin/bookings/${id}/toggle-paid`, {}, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const adminListSlotBlocks = (token) =>
  api.get("/admin/slot-blocks", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminCreateSlotBlock = (token, payload) =>
  api.post("/admin/slot-blocks", payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminDeleteSlotBlock = (token, id) =>
  api.delete(`/admin/slot-blocks/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminGetStats = (token) =>
  api.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
